import React from 'react';
interface SectionHeadingProps {
  id: string;
  title: React.ReactNode;
  eyebrow?: string;
  lead?: React.ReactNode;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  className?: string;
}

/** Orange technical eyebrow (with a fine rule) over an editorial serif title. */
export function SectionHeading({
  id,
  title,
  eyebrow,
  lead,
  tone = 'light',
  align = 'left',
  className = ''
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  const centered = align === 'center';
  return <div className={`${centered ? 'mx-auto text-center' : ''} max-w-3xl ${className}`} data-id="element-114" data-mp="gjq09s9fm9g3">
      {eyebrow && <p className={`label-tech flex items-center gap-3 ${centered ? 'justify-center' : ''} ${dark ? 'text-ember-light' : 'text-ember'}`} data-id="element-115" data-mp="1titwawp8gvr">
          <span className="h-px w-6 shrink-0 bg-current" aria-hidden data-id="element-116" data-mp="uizggrxn13k2" />
          {eyebrow}
        </p>}
      <h2 id={id} className={`font-display text-[1.7rem] leading-[1.14] min-[390px]:text-[1.8rem] sm:text-[2.35rem] lg:text-[2.8rem] lg:leading-[1.1] ${eyebrow ? 'mt-4' : ''} ${dark ? 'text-cream' : 'text-ink'}`} data-id="element-117" data-mp="zazn1387qupm">
        {title}
      </h2>
      {lead && <p className={`mt-4 text-[1rem] leading-relaxed sm:text-[1.08rem] ${centered ? 'mx-auto max-w-2xl' : 'max-w-2xl'} ${dark ? 'text-cream/70' : 'text-graphite'}`} data-id="element-118" data-mp="230tvbqkb6si6">
          {lead}
        </p>}
    </div>;
}